import React from 'react'
// import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import vw from 'styles/utils'

function Discount(props) {
	return (
		<Root>
			<Row>
				<Col>
					<a href='https://college.itri.org.tw/Home/LessonData/4EBC11E1-81D0-4DD0-80B3-DE33237C4CA4' target="_blank" rel="noreferrer">
						<img src={require('assets/images/home/ai-college/01-RTOS_1200x1200.png')} alt="RTOS_1200x1200" />
					</a>
				</Col>
				<Col>
					<a href='https://college.itri.org.tw/edm/D1/002/02/edm.html' target="_blank" rel="noreferrer">
						<img src={require('assets/images/home/ai-college/02-系列課程_1200x1200.png')} alt="" />
					</a>
				</Col>
			</Row>
			<DiscountCode href="https://ieknet.iek.org.tw/event/23event/ai/2023_ai.htm" target="_blank" rel="noreferrer">
				{/* <img src={require('assets/images/icons/discount.png')} alt="discount" />
				<DiscountContent>
					<h4>登入會員折扣碼</h4>
					<p>人工智慧學院課程優惠中</p>
				</DiscountContent> */}
			</DiscountCode>
		</Root>
	)
}

Discount.propTypes = {}

const Root = styled.div``;

const Row = styled.div`
	display: flex;

	${vw('column-gap', 24)}
`;

const Col = styled.div`
	img {
		width: 100%;
	}
`;

const DiscountCode = styled.a`
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 100%;
	background: url(${require('assets/images/home/hero/discount.png')});
	background-size: cover;
	background-position: center;

	/* ${vw('width', 588)} */
	${vw('height', 40, 105, 90)}
	/* ${vw('padding-top', 15)}
	${vw('padding-bottom', 15)}
	${vw('padding-left', 10, 30, 177)}
	${vw('padding-right', 10, 30, 177)} */
	${vw('margin-top', 10, 18, 24)}

	/* > img {
		${vw('width', 25, 40)}
		${vw('height', 25, 40)}
		${vw('margin-right', 10, 18)}
	} */
`;

// const DiscountContent = styled.div`
// 	display: flex;
// 	flex-direction: column;

// 	> h4 {
// 		font-family: 'Noto Sans TC';
// 		font-style: normal;
// 		font-weight: 500;
// 		letter-spacing: 0.05em;
// 		color: #252525;

// 		${vw('font-size', 10, 12, 18)}
// 		${vw('line-height', 14, 17, 26)}
// 		${vw('margin-bottom', 6)}
// 	}
// 	> p {
// 		font-family: 'Noto Sans TC';
// 		font-style: normal;
// 		font-weight: 400;
// 		line-height: 180%;
// 		text-align: center;
// 		color: #757575;

// 		${vw('font-size', 9, 11, 16)}
// 	}
// `;

export default Discount
